import ArrowIcon from './component'

export default ArrowIcon
